import { customerApi } from "../../utils/apiConfig";

export const postDolulukFormat = (excelFile) => {
  const formData = new FormData();
  formData.append("excel", excelFile);

  return customerApi.post("/dolulukHamadde", formData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
  });
};

export const getHatHizList = (payload) => {
  return customerApi.post("/getUretimHatHizStandart", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const addHatHizList = (payload) => {
  return customerApi.post("/insertUretimHatHizStandart", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteHatHizList = (payload) => {
  return customerApi.post(
    "/deleteUretimHatHizStandart",
    { id: payload },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const updateHatHizList = (id, payload) => {
  const dataToSend = { _id: id, ...payload };

  return customerApi.post("/updateUretimHatHizStandart", dataToSend, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const analyzeUretimPlanExcel = (file) => {
  const formData = new FormData();
  formData.append("excel", file);

  return customerApi.post("/analyzeUretimPlanExcel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const saveBulkUretimPlan = (planList) => {
  return customerApi.post(
    "/saveBulkUretimPlan",
    { planList },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

// 3. Mevcut aktif planları getirir
export const getUretimPlanList = () => {
  return customerApi.get("/getUretimPlanList", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const insertPlan = (payload) => {
  return customerApi.post("/insertPlan", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const calculatePlanTimePreview = (payload) => {
  return customerApi.post("/calculatePlanTimePreview", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updatePlan = (payload) => {
  return customerApi.post("/updatePlan", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const swapPlanOrder = (payload) => {
  return customerApi.post("/swapPlanOrder", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteUretimPlan = (payload) => {
  return customerApi.post("/deleteUretimPlan", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const calculateBestPlanPreview = (startDate, endDate) => {
  return customerApi.get(`/calculateBestPlanPreview/${startDate}/${endDate}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const applyAiOptimizedPlanApi = (data) => {
  return customerApi.post(`/applyAiOptimizedPlan`, data, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const hatHizEslestirmeAnaliz = (yil, ay) => {
  return customerApi.get(`/hizKontrol/${yil}/${ay}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
